import { Masonry, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { get } from '../../Common/api'
import CanceledChart from './CanceledChart'
import SlotEventsChart from './SlotEventsChart'
import Selectors from './Selectors'
import SlotsByDayChart from './SlotsByDayChart'
import dayjs from 'dayjs'
import DaySortBySlotsChart from './DaySortBySlotsChart'
import PatientOriginChart from './PatientOriginChart'

export default function BoxStatistics () {
  const [slots, setSlots] = useState()
  const [boxes, setBoxes] = useState()
  const [box, setBox] = useState()
  const [period, setPeriod] = useState()
  const [loading, setLoading] = useState(false)

  const getSlots = async (id) => {
    setLoading(true)
    await get({
      url: 'admin/statistics/slots',
      params: { box_id: id },
      onSuccess: (json) => {
        setSlots(json)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const getBoxes = async () => {
    await get({
      url: 'admin/statistics/boxes',
      params: {},
      onSuccess: (json) => {
        setBoxes(json)
      }
    })
  }

  useEffect(() => {
    getSlots('all')
    getBoxes()
    setPeriod({ start: dayjs('2026-01-19 00:00:00'), end: dayjs('2026-01-25 23:59:00') })
  }, [])

  const items = (slots) => {
    return [
      { key: 'slotsState', children: (<CanceledChart slots={slots} />) },
      { key: 'slotEvents', children: (<SlotEventsChart slots={slots} />) },
      { key: 'slotsByDay', children: (<SlotsByDayChart slots={slots} boxes={boxes} period={period} box={box} />) },
      { key: 'daySortBySlots', children: (<DaySortBySlotsChart slots={slots} />) },
      { key: 'patientOrigin', children: (<PatientOriginChart slots={slots} />) }
    ]
  }

  return (
    <Spin spinning={loading}>
      { boxes && <Selectors boxes={boxes} getSlots={getSlots} setBox={setBox} /> }
      { slots && boxes && <Masonry gutter={16} items={items(slots)} /> }
    </Spin>
  )
}
